module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"confirmPassword":"@:labels.confirmPassword","invalid":"@:labels.invalid","password":"@:labels.password","required":"@:labels.required","save":"@:labels.save","title":"Password"},"fr":{"confirmPassword":"@:labels.confirmPassword","invalid":"@:labels.invalid","password":"@:labels.password","required":"@:labels.required","save":"@:labels.save","title":"Mot de passe"}}')
  delete Component.options._Ctor
}
